import React from 'react';

export function Header(props) {
  return (
    <div className="header" style={{display:'flex', flexDirection:'row', alignItems:'center', backgroundColor:'white', padding:"24px", minHeight:34}}>
      {props.children}
    </div>
  );
}